export function moveItem<T>(items: readonly T[], from: number, to: number): T[] {
  const next = [...items];
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

export const watchlistInputClass =
  'h-8 min-w-0 w-full rounded-md border border-white/[.08] bg-white/[.04] px-2 font-mono text-[11px] text-zinc-100 outline-none placeholder:text-zinc-600 focus:border-white/[.18]';
export const watchlistIconClass =
  'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-white/[.08] bg-white/[.05] text-zinc-400 hover:bg-white/[.1] hover:text-zinc-100 disabled:cursor-not-allowed disabled:opacity-30';
export const watchlistButtonClass =
  'inline-flex h-8 items-center gap-1.5 rounded-md border border-white/[.08] bg-white/[.05] px-2.5 font-mono text-[10px] text-zinc-400 hover:bg-white/[.1] hover:text-zinc-100 disabled:cursor-not-allowed disabled:opacity-30';
